import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import RowAddButton from '@/components/buttons/RowAddButton';
import { addVocabularyLink } from '../actions';

const VocabularyLinksTableFooter = ({ showEmptyRow, entity = 'link', colSpan = 4 }) => (
  <Table.Footer fullWidth>
    <Table.Row>
      <Table.HeaderCell colSpan={colSpan}>
        <RowAddButton entity={`vocabulary.${entity}`} onClick={showEmptyRow} />
      </Table.HeaderCell>
    </Table.Row>
  </Table.Footer>
);

const mapDispatchToProps = {
  showEmptyRow: addVocabularyLink,
};

export default connect(null, mapDispatchToProps)(VocabularyLinksTableFooter);
